<template>
  <!-- 弹出经销商选出 -->
  <el-dialog
    title="确认跟进需求"
    :visible.sync="distributeShow"
    :close-on-click-modal="false"
    class="select-merchant-box"
    width="460px"
  >
    <div class="demand-distribute">
      <div class="hint"></div>
      <el-form>
        <el-form-item label="选择跟进人">
          <el-select
            v-loading="merchantsLoading"
            v-model="selectedMerchant"
            placeholder="请指派旗下经销商"
          >
            <el-option
              v-for="item in merchants"
              :key="item.id"
              :value="item.id"
              :label="`${item.name}[${item.contact}-${item.phone}]`"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="bts">
          <el-button type="hollow" @click="onCancelMerchant">取消</el-button>
          <el-button :loading="distributeLoading" type="submit" @click="onSubmitMerchant"
            >确定</el-button
          >
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { merchants as getMerchants } from "@/api/store/";
import { distribute } from "@/api/user";
export default {
  name: "c-select-merchant",
  props: ["demandID", "show", "callback"],
  watch: {
    show(val) {
      this.distributeShow = val;
    },
    distributeShow(val) {
      if (val) {
        this.merchantsLoading = true;
        getMerchants()
          .then((res) => {
            const { data } = res;
            this.merchants = data;
          })
          .finally(() => {
            this.merchantsLoading = false;
          });
      } else {
        this.$emit("onClose");
      }
    },
  },
  data() {
    return {
      distributeShow: false,
      merchants: [],
      merchantsLoading: false,
      selectedMerchant: "",
      distributeLoading: false,
    };
  },
  mounted() {},
  methods: {
    showDistribution() {
      this.distributeShow = true;
    },
    onCancelMerchant() {
      this.distributeShow = false;
      this.selectedMerchant = "";
    },
    onSubmitMerchant() {
      if (this.selectedMerchant) {
        this.distributeLoading = true;
        distribute(this.demandID, this.selectedMerchant)
          .then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.onCancelMerchant();
              if (this.callback) {
                this.callback();
              }
            }
          })
          .finally(() => {
            this.distributeLoading = false;
          });
      }
    },
  },
};
</script>
